import { SubscriptionPeriod, SubscriptionType } from "../../payments.model";
import { LITE_SUBSCRIPTION_PRICING } from "./pricing.const";

export const getPricingAmount = ({
  subscriptionType,
  subscriptionPeriod,
}: {
  subscriptionType: SubscriptionType;
  subscriptionPeriod: SubscriptionPeriod;
}): number => {
  const pricing = LITE_SUBSCRIPTION_PRICING[subscriptionType];

  if (subscriptionPeriod === SubscriptionPeriod.Monthly) {
    return pricing.priceMonthly;
  }

  return pricing.priceAnnual;
};
